import { ViewChild, Component, Renderer, HostListener } from '@angular/core';
import {
    ViewController,
    NavParams, 
    Platform,
    PopoverController} from 'ionic-angular';

import { Keyboard } from '@ionic-native/keyboard';

import { DataService } from '../../services/data';
import { AlertMessager } from '../../lib/alertMessager';

import { Account } from '../../model/account';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { NewMemberPage } from '../staff/rodeo/memberships/new-member';

@Component({
    selector: 'user-search',
    templateUrl: 'user-search.html'
})
export class UserSearchPopover {
    @ViewChild('userSearch') userSearch;

    searchTitle: string = "Account Search";
    allowDraw: boolean;
    allowTba: boolean;
    searchChangeObservable;
    selecting: boolean = false;
    
    results: any = [];
    searchValue: string = '';
    staff: boolean = false;
    selectedAccount: Account;
    loadingData: boolean = false;
    popoverActive: boolean = false;
    organizations: any = [];
    
    constructor(
                private _viewCtrl: ViewController,
                private popoverController: PopoverController,
                private navParams: NavParams,
                private data: DataService,
                private renderer: Renderer,
                private alert: AlertMessager,
                private keyboard: Keyboard,
                private platform: Platform) {
        this.searchTitle = this.navParams.get('searchTitle');
        this.staff = !platform.is("ios") && !platform.is("android");
        this.organizations = this.navParams.get('organizations');
        this.allowDraw = this.navParams.get('allowDraw');
        this.allowTba = this.navParams.get('allowTba');
    }

    ionViewDidEnter() {
        const element = this.userSearch._elementRef.nativeElement.querySelector('input');
        // we need to delay our call in order to work with ionic ...
        setTimeout(() => {
            this.renderer.invokeElementMethod(element, 'focus', []);
            this.keyboard.show();
        }, 0);
    }

    onSearchChange(searchEvent, searchValue : string) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(300) // wait 300ms after the last event before emitting last event
              .distinctUntilChanged() // only emit if value is different from previous value
              .subscribe((searchValue) => { this.searchForAccount(searchEvent, searchValue) });
        }

		this.searchChangeObservable.next(searchValue);
    }

	searchForAccount(searchEvent, searchValueInc : string) {
        this.loadingData = true;
        let firstName = this.searchValue;
        let lastName = '';
        
        if (this.searchValue.indexOf(' ') > 0) {
            firstName = this.searchValue.split(' ')[0];
            lastName = this.searchValue.split(' ')[1];
        }

        if (this.staff) {
            this.data.getStaffUserSearch(firstName, lastName)
            .then(data => {
                this.loadingData = false;
                this.results = data;
    
                if (this.results.length > 0) {
                    this.selectedAccount = this.results[0];
                } else {
                    this.selectedAccount = null;
                }
            })
            .catch(error => {
                this.loadingData = false;
                this.alert.showError('Error', 'Unable to retrieve search results: ' + error);
            });
        } else {
            this.data.getUserSearch(firstName, lastName)
            .then(data => {
                this.loadingData = false;
                this.results = data;

                if (this.results.length > 0) {
                    this.selectedAccount = this.results[0];
                } else {
                    this.selectedAccount = null;
                }
            })
            .catch(error => {
                this.loadingData = false;
                this.alert.showError('Error', 'Unable to retrieve search results: ' + error)
            });
        }
	}

    selectItem(item) {
        this._viewCtrl.dismiss({ buddies: [ item ] })
    }

    selectDraw() {
        this._viewCtrl.dismiss({ buddies: [ { firstName: 'Draw' } ] })
    }

    selectTba() {
        this._viewCtrl.dismiss({ buddies: [ { firstName: 'Tba' } ] })
    }

    getSearchMessage() {
        if (this.searchValue == undefined || this.searchValue.trim().length == 0)
            return "";
        else if (this.results == undefined || this.results.length < 1)
            return "There are no users by that name.";

        return "";
    }

    addNewAccount() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        let firstName = '';
        let lastName = '';

        if (this.searchValue.indexOf(' ') > 0) {
            firstName = this.searchValue.split(' ')[0];
            lastName = this.searchValue.split(' ')[1];
        }

        let newAccount = null;

        let callback = (account) => {
            newAccount = account;
        }

        let entryModal = this.popoverController.create(NewMemberPage, { account: null, organizations: this.organizations, callback: callback, firstName: firstName, lastName: lastName }, { cssClass: 'page-new-member', enableBackdropDismiss: true });

        entryModal.present();
        entryModal.onDidDismiss((data) =>{
            this.popoverActive = false;

            console.log("newAccount: ", newAccount);

            if (newAccount != null)
                this._viewCtrl.dismiss({ buddies: [ newAccount ] });
        });
    }

    _bdClick() {
        return this._viewCtrl.dismiss({ buddies: [ this.selectedAccount ] }, 'backdrop');
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (!this._viewCtrl.isLast())
            return;

        if (ev.keyCode === 27) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        } else if (ev.keyCode === 38 && this.results.length > 0) {
            if (this.results[0] !== this.selectedAccount) {
                let index = this.results.indexOf(this.selectedAccount);

                this.selectedAccount = this.results[index - 1];                
            }
        } else if (ev.keyCode === 40 && this.results.length > 0) {
            if (this.results[this.results.length - 1] !== this.selectedAccount) {
                let index = this.results.indexOf(this.selectedAccount);

                this.selectedAccount = this.results[index*1 + 1];                
            }
        } else if (ev.keyCode === 13 && this.selectedAccount != null) {
            this.selectItem(this.selectedAccount);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/search/user-search.ts